
  document.addEventListener('DOMContentLoaded', function () {
    /* FAQ accordion */
    var accordions = document.querySelectorAll('[data-faq-accordion]');

    accordions.forEach(function (accordion) {
      var items = accordion.querySelectorAll('.faq-item');

      items.forEach(function (item) {
        var trigger = item.querySelector('.faq-trigger');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          items.forEach(function (otherItem) {
            if (otherItem !== item) otherItem.classList.remove('is-open');
          });
          item.classList.toggle('is-open');
        });
      });
    });

    /* Sliders */
    var sliders = document.querySelectorAll('[data-host-slider]');

    sliders.forEach(function (slider) {
      var track = slider.querySelector('.host-slider__track');
      var slides = slider.querySelectorAll('.host-slider__slide');
      var prevBtn = slider.querySelector('.host-slider__nav--prev');
      var nextBtn = slider.querySelector('.host-slider__nav--next');
      var dotsContainer = slider.querySelector('.host-slider__dots');

      if (!track || !slides.length || !dotsContainer) return;

      var currentIndex = 0;
      var slideCount = slides.length;

      dotsContainer.innerHTML = '';

      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'host-slider__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (index + 1));
        dot.addEventListener('click', function () {
          goToSlide(index);
        });
        dotsContainer.appendChild(dot);
      });

      var dots = dotsContainer.querySelectorAll('.host-slider__dot');

      function goToSlide(index) {
        if (index < 0) index = slideCount - 1;
        if (index >= slideCount) index = 0;

        currentIndex = index;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentIndex + 1); });

      var startX = null;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var endX = e.changedTouches[0].clientX;
        var diff = endX - startX;
        if (Math.abs(diff) > 40) {
          goToSlide(diff < 0 ? currentIndex + 1 : currentIndex - 1);
        }
        startX = null;
      });
    });
  });
